<script>
  import {onMount, createEventDispatcher} from 'svelte';
  import {IMAGES} from '@/const/images';
  import {mc} from '@/core';
  import {userApi} from '@/api/user';
  import VerifyCodeInput from '@/widgets/VerifyCodeInput.svelte';
  import DrawerModal from '@/widgets/DrawerModal.svelte';
  import lang from '@/modules/register-landing/RegisterLandingPage.lang';
  import errors from '@/modules/error/error.lang';

  export let LG = null;
  export let emailData = null;

  const dispatch = createEventDispatcher();

  let status = '';
  let explain = '';
  let count = 60;
  let typeRef = null;
  let contextRef = null;
  let callbackRef = null;

  onMount(() => {
    typeRef = emailData.type;
    contextRef = emailData.context;
    callbackRef = emailData.callback;
    setTimeout(() => {
      postMailCode();
    }, 0);
  });

  function handleCodeChange(e) {
    const emitCode = e.detail.value;
    status = 'loading';
    const callback = ({code, message}) => {
      if (code === 0) {
        dispatch('close');
        handleClickClose();
        status = 'success';
        return;
      }
      status = 'fail';
      const id = errors[code];
      explain = id ? LG(id) : message;
    };
    callbackRef && callbackRef(emitCode, callback, contextRef);
  }

  function handleInputCode() {
    status = '';
    explain = '';
  }

  function countDown() {
    const nextTime = Date.now() + 60000;
    localStorage.setItem('count_down_mail', String(nextTime));
    count = 60;
    const timer = setInterval(() => {
      const nextTime = localStorage.getItem('count_down_mail') || '0';
      const now = Date.now();
      count = Math.floor((Number(nextTime) - now) / 1000);
      if (count < 0) {
        clearInterval(timer);
      }
    }, 500);
  }

  async function postMailCode() {
    const query = {
      type: typeRef,
    };
    const {data, error} = await userApi.codesMail(query);
    if (data) {
      mc.send('toast', 'info', {message: LG(lang.Verification)});
      countDown();
    }
    if (error) {
      mc.send('toast', 'error', error);
    }
  }

  function handleClickClose() {
    resetData();
    dispatch('close');
  }

  function resetData() {
    status = '';
    explain = '';
    contextRef = null;
    callbackRef = null;
    typeRef = null;
    count = 60;
  }
</script>

<style>
  .wrap {
    height: 100%;
  }
  .title {
    margin-top: 70px;
    font-size: 48px;
  }
  .sub-title {
    margin-top: 40px;
  }
  .iconfont {
    font-size: 12px;
  }
  .arrow {
    transform: rotate(-180deg);
  }
  .email-gif {
    width: 100px;
    height: 100px;
  }
  .code :global(.digit-box span) {
    font-size: 36px;
    font-weight: var(--fw3);
    color: #003fe6;
  }
  @media screen and (max-width: 640px) {
    .title {
      font-size: 24px;
    }
    .sub-title {
      margin-top: 40px;
    }
  }
</style>

<DrawerModal visible>
  <div class="wrap">
    <div class="df aic cp" on:click={handleClickClose}>
      <div class="arrow">
        <i class="iconfont BLUE">&#xe60b;</i>
      </div>
      <span class="BLUE ml10">{LG(lang.Back)}</span>
    </div>
    <div class="form">
      <div class="title">{LG(lang.EmailVerification)}</div>
      <div class="mt20 tc">
        <img class="email-gif" src={IMAGES.REGISTER_LANDING_PAGE_EMAIL_GIF} alt="email" />
      </div>
      <div class="sub-title T4">{LG(lang.PleaseEnterYourEmail)}</div>
      <div class="code mt16">
        <VerifyCodeInput {status} {explain} on:change={handleCodeChange} on:input={handleInputCode} />
      </div>
      <div class="mt16 T3">{LG(lang.MakeSure)}</div>
      <div class="send mt10 BLUE tc">
        {#if count > 0}
          <span class="default">{count}s</span>
        {:else}
          <span class="f14 lh22 cp ml4 BLUE " on:click={postMailCode}>{LG(lang.SendAgain)}</span>
        {/if}
      </div>
    </div>
  </div>
</DrawerModal>
